import { useContext } from "react";
import { CSSCustomPropertyContext } from "../../context/cssCustomProperty";
function useCSSCustomProperty(key, fallback) {
    const properties = useContext(CSSCustomPropertyContext);
    return properties[key] ?? fallback;
}
export { useCSSCustomProperty };
